import * as constants from "./constants";

const initialState = {
  allReportDetail: [],
  allClasses: [],
  loading: false,
  classes: [],
  students: [],
  filteredStudents: [],
  selectedClassId: null,
  selectedStudentId: null,
  reportData: null,
  error: null,
  reportTypeOptions: [],
  classEnrolment: null,
};

const semesterReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_CLASSES_STUDENTS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case constants.FETCH_CLASSES_STUDENTS_SUCCESS: {
      const classes = action.payload?.data?.classes || [];

      const formattedClasses = classes.map((cls) => ({
        _id: cls._id,
        id: cls.id,
        name: cls.name,
      }));

      const students = classes.flatMap((cls) =>
        cls.students.map((student) => ({
          id: student._id,
          name: `${student.first_name} ${student.last_name}`,
          login_id: student.login_id,
          gender: student.gender,
          image_path: student.image_path,
          year_level: student.year_level,
          classId: cls._id,
          // classId: cls.id,
          className: cls.name,
        }))
      );

      return {
        ...state,
        loading: false,
        classes: formattedClasses,
        students,
        filteredStudents: [],
      };
    }

    // case constants.SET_SELECTED_CLASS: {
    //   const classId = action.payload;
    //   const filtered = state.students.filter(
    //     (student) => student.classId === classId
    //   );
    //   console.log("Filtered students:", filtered);
    //   return {
    //     ...state,
    //     selectedClassId: classId,
    //     selectedStudentId: null,
    //     filteredStudents: filtered,
    //   };
    // }

case constants.SET_SELECTED_CLASS: {
  const classIds = Array.isArray(action.payload)
    ? action.payload
    : [action.payload]; // hamesha array banado

  const filtered = state.students.filter((student) =>
    classIds.includes(student.classId)
  );

  return {
    ...state,
    selectedClassIds: classIds,
    selectedStudentId: null,
    filteredStudents: filtered,
  };
}



    // case constants.SET_SELECTED_CLASS: {
    //   const classIds = Array.isArray(action.payload)
    //     ? action.payload
    //     : [action.payload]; // ensure always array

    //   const filtered = state.students.filter((student) =>
    //     classIds.includes(student.classId)
    //   );

    //   return {
    //     ...state,
    //     selectedClassIds: classIds,
    //     selectedStudentId: null, // reset student when class changes
    //     filteredStudents: filtered,
    //   };
    // }

    case constants.SET_REPORT_DATA:
      return {
        ...state,
        reportData: action.payload,
        loading: false,
        error: null,
      };

    case constants.SET_SELECTED_STUDENT:
      return {
        ...state,
        selectedStudentId: action.payload,
      };

    case constants.REVIEW_REPORT:
      return {
        ...state,
        loading: true,
        error: null,
        reportData: null,
      };

    case constants.REVIEW_REPORT_SUCCESS:
      console.log("Reducer received:", action.payload);
      return {
        ...state,
        loading: false,
        classEnrolment: action.payload,
      };

    case constants.REVIEW_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload?.message || "Failed to review report",
      };

       case constants.GENERATE_REPORT:
      return { ...state, loading: true, error: null };

    case constants.GENERATE_REPORT_SUCCESS:
      return { ...state, loading: false, report: action.data };

    case constants.GENERATE_REPORT_ERROR:
      return { ...state, loading: false, error: action.error };

    default:
      return state;
  }
};

export default semesterReportReducer;
